import { redirect } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

const KEY = 'post-login-redirect';

// `/login` is silently dropped so a stash from the login page can't pin itself
// and cause a redirect loop on the post-callback restore.
export function stashIntended(path: string) {
  if (path !== '/login') sessionStorage.setItem(KEY, path);
}

// Read-and-clear: the next caller gets null, so a refresh after restore can't re-trigger the redirect.
export function popIntended(): string | null {
  const v = sessionStorage.getItem(KEY);
  if (v) sessionStorage.removeItem(KEY);
  return v;
}

// Short-circuit unauthenticated route loads before they hit the API, stashing
// the URL so the post-OAuth restore can return the user here instead of /.
export function requireAuth(request: Request) {
  if (useAuthStore.getState().isAuthenticated) return;
  const url = new URL(request.url);
  stashIntended(url.pathname + url.search);
  throw redirect('/login');
}
